exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._31WrheaodkMTYsosFPVoqF {\n  margin: 20px;\n}\n._2oJYtlJ2dNvC8KGFXIhyQJ {\n  width: 100%;\n}\n", ""]);

// Exports
exports.locals = {
	"pageWrapper": "_31WrheaodkMTYsosFPVoqF",
	"imgResponsive": "_2oJYtlJ2dNvC8KGFXIhyQJ"
};